import { gsap, SplitText } from "@gsap";

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".flex-layout.intro_content-layout").forEach((layout) => {
        const text = layout.querySelector(".intro-content-title .pk-heading-text");
        if (!text) return;

        gsap.matchMedia().add("(prefers-reduced-motion: no-preference)", () => {
            const split = SplitText.create(text, { type: "words, chars", charsClass: "intro-char" });

            split.chars.forEach((char) => {
                char.dataset.char = char.textContent;
                char.style.display = "inline-flex";
                char.style.flexDirection = "column";
            });

            gsap.fromTo(
                split.chars,
                { fontWeight: 400 },
                {
                    fontWeight: 700,
                    stagger: 0.1,
                    ease: "power1.inOut",
                    scrollTrigger: {
                        trigger: layout,
                        start: "top 75%",
                        end: "top top",
                        scrub: 1.1,
                    },
                }
            );

            return () => split.revert();
        });
    });
});
